import React from "react"
import Header from "./Component/Head/Header"
import "./App.css"
import Accueil from "./Component/Accueil/Accueil"
import Parcours from "./Component/Parcours/Parcours"



const App = ()=> {
  return( 
    <>
    <Header />
    <Accueil />
    <Parcours />
*    </>
  )
}
export default App